<link
  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
  rel="stylesheet"
/>

<style>
  .dropdown-menu {
    width: 500px;
    overflow-y: scroll;
  }
</style>
<!-- <div class="btn-group">
    <button type="button" class="btn btn-primary dropdown-toggle border border-1" data-bs-toggle="dropdown" aria-expanded="false">
      <i class="fas fa-bell fa" ></i>
      <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
          {{ recentPackagesList.length }}
      </span>
    </button>
    
    <ul class="dropdown-menu overflow-auto" style="max-height: 300px;"aria-labelledby="dropdownMenuButton1">
        <li *ngIf="recentPackagesList.length === 0">
            <div class="dropdown-item ">No New Orders</div>
        </li>
      <li  >
          <div *ngFor="let data of recentPackagesList " >
              <div class="m-2 d-flex flex-row justify-content-between"><h5 class="m-0 text-success fw-bold">Package ID : {{ data.packageID }} </h5> 
                <a (click)="routeViewDetails(data)" href='dashboard/viewPackageDetails?id={{data._id}}' class="btn btn-primary btn-sm ">View Details</a> </div>
              
              <div  >
                  <div class="row m-1" >
                      <div class="col "><h6 class="m-0 text-primary fw-bold">From :</h6> <p>{{data.fromAddress}}</p></div>
                      <div class="col "><h6 class="m-0 text-primary fw-bold">To :</h6> <p>{{data.toAddress}}</p></div>
                      
                  </div>
              </div>
              <hr class="m-0">
          </div>
          
      </li>
  
    </ul>
  </div> -->

<div>
  <!-- <div class="btn-group m-2">
    <button
      type="button"
      class="btn btn-primary dropdown-toggle border border-1"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      <i class="fas fa-bell fa"></i>
      <span
        *ngIf="recentPackagesList.length > 0"
        class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
      >
        {{ recentPackagesList.length }}
      </span>
    </button>

    <ul
      class="dropdown-menu overflow-auto"
      style="max-height: 300px"
      aria-labelledby="dropdownMenuButton1"
    >
      <li *ngIf="recentPackagesList.length > 0">
        <h5 class="text-center fw-bold">Orders</h5>
        <hr />
      </li>
      <li *ngIf="recentPackagesList.length === 0">
        <div class="dropdown-item">No New Orders</div>
      </li>
      <li>
        <div *ngFor="let data of recentPackagesList">
          <div class="m-2 d-flex flex-row justify-content-between">
            <h5 class="m-0 text-success fw-bold">
              Package ID : {{ data.packageID | uppercase }}
            </h5>
            <a
              (click)="routeViewDetails(data)"
              href="dashboard/viewPackageDetails?id={{ data._id }}"
              class="btn btn-primary btn-sm"
              >View Details</a
            >
          </div>

          <div>
            <div class="row m-1">
              <div class="col">
                <h6 class="m-0 text-primary fw-bold">From :</h6>
                <p>{{ data.fromAddress }}</p>
              </div>
              <div class="col">
                <h6 class="m-0 text-primary fw-bold">To :</h6>
                <p>{{ data.toAddress }}</p>
              </div>
            </div>
          </div>
          <hr class="m-0" />
        </div>
      </li>
    </ul>
  </div> -->

  <!-- <div class="btn-group m-2">
    <button
      type="button"
      class="btn btn-primary dropdown-toggle border border-1"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      ET <i class="fas fa-bell fa"></i>
      <span
        *ngIf="recentENTPPackagesList.length > 0"
        class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
      >
        {{ recentENTPPackagesList.length }}
      </span>
    </button>

    <ul
      class="dropdown-menu overflow-auto"
      style="max-height: 300px"
      aria-labelledby="dropdownMenuButton1"
    >
      <li *ngIf="recentENTPPackagesList.length > 0">
        <h5 class="text-center fw-bold">Enterprise Orders</h5>
        <hr />
      </li>
      <li *ngIf="recentENTPPackagesList.length === 0">
        <div class="dropdown-item">No New Enterprise Orders</div>
      </li>
      <li>
        <div *ngFor="let data of recentENTPPackagesList">
          <div class="m-2 d-flex flex-row justify-content-between">
            <h5 class="m-0 text-success fw-bold">
              Trip ID : {{ data.tripCode | uppercase }}
            </h5>
            <a
              (click)="routeViewDetails(data)"
              href="dashboard/enterprise-view-trip?id={{ data._id }}"
              class="btn btn-primary btn-sm"
              >View Details</a
            >
          </div>
          <hr class="m-0" />
        </div>
      </li>
    </ul>
  </div> -->

  <!-- <div class="btn-group m-2">
    <button
      type="button"
      class="btn btn-primary dropdown-toggle border border-1"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      PM <i class="fas fa-bell fa"></i>
      <span
        *ngIf="recentPMList.length > 0"
        class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
      >
        {{ recentPMList.length }}
      </span>
    </button>

    <ul
      class="dropdown-menu overflow-auto"
      style="max-height: 300px"
      aria-labelledby="dropdownMenuButton1"
    >
      <li *ngIf="recentPMList.length > 0">
        <h5 class="text-center fw-bold">Packers And Movers Orders</h5>
        <hr />
      </li>
      <li *ngIf="recentPMList.length === 0">
        <div class="dropdown-item">No New Packers and Movers Order</div>
      </li>
      <li>
        <div *ngFor="let data of recentPMList">
          <div class="m-2 d-flex flex-row justify-content-between">
            <h5 class="m-0 text-success fw-bold">
              Package ID : {{ data.packageID | uppercase }}
            </h5>
            <p class="m-0 fw-bold">SD: {{ data.shiftingDate }}</p>
            <a
              (click)="routeViewPMDetails(data)"
              href="dashboard/viewPackerMoverRequest?id={{ data._id }}"
              class="btn btn-primary btn-sm"
              >View Details</a
            >
          </div>

          <div>
            <div class="row m-1">
              <div class="col">
                <h6 class="m-0 text-primary fw-bold">From :</h6>
                <p>{{ data.fromAddress }}</p>
              </div>
              <div class="col">
                <h6 class="m-0 text-primary fw-bold">To :</h6>
                <p>{{ data.toAddress }}</p>
              </div>
            </div>
          </div>
          <hr class="m-0" />
        </div>
      </li>
    </ul>
  </div> -->

  <!-- <div class="btn-group m-2">
    <button
      type="button"
      class="btn btn-primary dropdown-toggle border border-1"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      D-W <i class="fas fa-bell fa"></i>
      <span
        *ngIf="recentWithdrawalList.length > 0"
        class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
      >
        {{ recentWithdrawalList.length }}
      </span>
    </button>

    <ul
      class="dropdown-menu overflow-auto"
      style="max-height: 300px"
      aria-labelledby="dropdownMenuButton1"
    >
  
      <li *ngIf="recentWithdrawalList.length === 0">
        <div class="dropdown-item">No new driver withdrawal requests</div>
      </li>
      <li *ngIf="recentWithdrawalList.length > 0">
        <div class="dropdown-item">New withdrawal request raised by driver</div>
      </li>
    </ul>
  </div> -->

  <div class="btn-group m-2">
    <button
      type="button"
      class="btn btn-primary dropdown-toggle border border-1 position-relative"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      <i class="fas fa-bell"></i>

      <span
        *ngIf="notifications.length > 0"
        class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
      >
        {{ notifications.length }}
      </span>
    </button>

    <ul
      class="dropdown-menu overflow-auto"
      style="max-height: 350px; width: 350px"
    >
      <li class="px-3 py-2 border-bottom">
        <strong>Notifications</strong>
      </li>

      <li *ngIf="notifications.length === 0">
        <div class="dropdown-item text-center">No new notifications</div>
      </li>

      <li
        *ngFor="let notification of notifications"
        (click)="openNotification(notification)"
        style="cursor: pointer"
      >
        <div class="dropdown-item text-wrap">
          <div class="fw-bold">
            {{ notification.title }}
          </div>

          <div class="small text-muted">
            {{ notification.message }}
          </div>

          <div class="small text-secondary mt-1">
            {{ notification.createdAt | date: "dd MMM yyyy, hh:mm a" }}
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>
